$(document).ready(function() {
    $('#js-usa, #js-mexico, #js-brazil, #js-middle-east').on('change', function(){
        window.location.href = this.value;
    }); 
});